import { useCallback, useEffect, useState, useTransition } from "react";
import { logger } from "@/lib/logger";
import { fetchUserAnalyticsBigQueries } from "../../action";

export interface BigQuery {
  bigQueryID: string;
  name: string;
  isActive: boolean;
}

export function useBigQuery(workspaceId: string, isFormReadyForUA: boolean) {
  const [bigQueries, setBigQueries] = useState<BigQuery[]>([]);
  const [selectedBigQueryId, setSelectedBigQueryId] = useState<string>("");
  const [isPending, startTransition] = useTransition();
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!isFormReadyForUA) return;

    startTransition(async () => {
      try {
        const result = await fetchUserAnalyticsBigQueries(workspaceId);
        if (result && Array.isArray(result)) {
          // Map the result to the expected BigQuery format
          const mappedBigQueries: BigQuery[] = result.map((bq) => ({
            bigQueryID: bq.id,
            name: `${bq.projectID} - ${bq.datasetName}`,
            isActive: true, // Assume all returned BigQueries are active
          }));
          setBigQueries(mappedBigQueries);
          // 1つしかない場合は自動選択
          if (mappedBigQueries.length === 1 && mappedBigQueries[0]) {
            setSelectedBigQueryId(mappedBigQueries[0].bigQueryID);
          }
        }
        setHasFetched(true);
      } catch (error) {
        logger.error("Failed to fetch BigQuery configurations:", error);
        setHasFetched(true);
      }
    });
  }, [workspaceId, isFormReadyForUA]);

  const handleBigQueryChange = useCallback((id: string) => {
    setSelectedBigQueryId(id);
  }, []);

  return {
    bigQueries,
    selectedBigQueryId,
    isFetching: isPending,
    hasFetched,
    handleBigQueryChange,
  };
}
